<template>
    <div class="page-title d-flex flex-column gap-2" :class="{ 'sticky': sticky }">
        <div class="d-flex flex-wrap gap-3 justify-content-between align-items-center flex-grow-1">
            <component :is="titleTag" class="m-0 mb-auto height-min-40 d-flex align-items-center" :class="titleClass">
                <span :id="headerId" class="text-link-header"><slot>{{ title }}</slot></span>
            </component>
            <div class="d-flex gap-2 justify-content-end align-items-center" :class="sideClass">
                <b-breadcrumb :items="items" class="breadcrumb" />
                <div class="side">
                    <slot name="side"></slot>
                </div>
            </div>
        </div>
        <div v-if="$slots.subtitle || subtitle" class="page-subtitle" :class="subtitleClass">
            <slot name="subtitle">{{ subtitle }}</slot>
        </div>
        <div v-if="$slots.bottom" class="page-subtitle" :class="bottomClass">
            <slot name="bottom"></slot>
        </div>
    </div>
</template>



<script>
    export default {
        name: 'PageHeader',
        props: {
            items: {
                type: Array,
                default: () => [],
            },
            title: {
                type: String,
                default: null,
            },
            titleTag: {
                type: String,
                default: 'h4',
            },
            subtitle: {
                type: String,
                default: null,
            },
            titleClass: {
                type: [String, Object],
                default: null,
            },
            subtitleClass: {
                type: [String, Object],
                default: null,
            },
            bottomClass: {
                type: [String, Object],
                default: null,
            },
            sideClass: {
                type: [String, Object],
                default: null,
            },
            headerId: {
                type: String,
                default: null,
            },
            sticky: {
                type: Boolean,
                default: true,
            },
        },
    };
</script>



<style lang="scss" scoped>
    .page-title.sticky {
        background-color: $body-bg;
        position: sticky;
        top: $topbar-height;
        z-index: 20;
        margin-bottom: auto;
    }
</style>
